import { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  MenuItem,
  Switch,
  FormControlLabel
} from '@mui/material';
import { useDateRangeContext } from 'contexts/DateRangeContext';
import api from 'state/axios';
import SectionLabel from 'components/SectionLabel';
import FieldDisplay from 'components/FieldDisplay';


const INSURANCE_OPTIONS = [
  { value: 'paidDays', label: 'Paid Days' },
  { value: 'workingDays', label: 'Working Days' },
];


const CrewPayroll = ({
  values,
  handleChange,
  handleBlur,
  setFieldValue,
  isEditMode
}) => {
  const { startDate, endDate } = useDateRangeContext();
  const [contributions, setContributions] = useState([]);

  useEffect(() => {
    if (!startDate || !endDate) return;
    api.post('/contributions/active', { startDate, endDate })
      .then((res) => setContributions(res.data || []))
      .catch(() => {});
  }, [startDate, endDate]);

  const insuranceLabel = INSURANCE_OPTIONS.find(o => o.value === values.insuranceDayCalculationType)?.label
    || values.insuranceDayCalculationType || '-';

  if (!isEditMode) return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      gap={2}
    >
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 4' } }}>
        <FieldDisplay label="Base Salary" value={values.baseSalary ? values.baseSalary.toLocaleString() : null} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 4' } }}>
        <FieldDisplay label="Contribution Object" value={values.contributionObject} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 4' } }}>
        <FieldDisplay label="Insurance Day Calculation" value={insuranceLabel} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 4' } }}>
        <FieldDisplay label="Net Income" value={values.isNetIncome ? 'Yes' : 'No'} />
      </Box>
      <SectionLabel>Bank Account</SectionLabel>
      <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}>
        <FieldDisplay label="Bank Name" value={values.bankAccount?.bankName} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}>
        <FieldDisplay label="Account Number" value={values.bankAccount?.accountNumber} />
      </Box>
    </Box>
  );

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      gap={2}
    >
      <TextField
        fullWidth
        size="small"
        label="Base Salary"
        name="baseSalary"
        type="number"
        value={values.baseSalary}
        onChange={handleChange}
        onBlur={handleBlur}
        slotProps={{ htmlInput: { min: 0, style: { textAlign: 'right' } } }}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />

      <TextField
        fullWidth
        select
        size="small"
        label="Contribution Object"
        name="contributionObject"
        value={values.contributionObject || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        slotProps={{ inputLabel: { shrink: true } }}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      >
        <MenuItem value=""><em>None</em></MenuItem>
        {contributions.map(c => (
          <MenuItem key={c._id} value={c.contributionObject}>
            {c.contributionObject} - {c.description}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        fullWidth
        select
        size="small"
        label="Insurance Day Calculation"
        name="insuranceDayCalculationType"
        value={values.insuranceDayCalculationType || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        slotProps={{ inputLabel: { shrink: true } }}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      >
        <MenuItem value=""><em>None</em></MenuItem>
        {INSURANCE_OPTIONS.map(o => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gridColumn: { xs: 'span 12', sm: 'span 4' },
        }}
      >
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={values.isNetIncome}
              onChange={(e) => setFieldValue('isNetIncome', e.target.checked)}
            />
          }
          label="Net Income"
        />
      </Box>

      <SectionLabel>Bank Account</SectionLabel>

      <TextField
        fullWidth
        size="small"
        label="Bank Name"
        value={values.bankAccount?.bankName || ''}
        onChange={(e) => setFieldValue('bankAccount.bankName', e.target.value)}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}
      />
      <TextField
        fullWidth
        size="small"
        label="Account Number"
        value={values.bankAccount?.accountNumber || ''}
        onChange={(e) => setFieldValue('bankAccount.accountNumber', e.target.value)}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}
      />
    </Box>
  );
};

export default CrewPayroll;
